import invert from 'lodash/invert';

export const MODULE_NAME = 'restaurant';

const prefix = `${MODULE_NAME}/`;

export const ACTION_TYPES = {
    READ_INFO: `${prefix}READ_INFO`,
    SHOW_INFO: `${prefix}SHOW_INFO`,
    HIDE_INFO: `${prefix}HIDE_INFO`,
    RESTAURANT_INITIALIZED: `${prefix}RESTAURANT_INITIALIZED`,
    RESTAURANT_CANNOT_BE_INITIALIZED: `${prefix}RESTAURANT_CANNOT_BE_INITIALIZED`,
    CALL_WAITER: `${prefix}CALL_WAITER`,
    CALL_WAITER_FAILED: `${prefix}CALL_WAITER_FAILED`,
    CALL_WAITER_SUCCESS: `${prefix}CALL_WAITER_SUCCESS`,
    WAITER_CALLED: `${prefix}WAITER_CALLED`,
    LAST_BILL_FETCHED: `${prefix}LAST_BILL_FETCHED`,
    LAST_BILL_FETCHING_FAILED: `${prefix}LAST_BILL_FETCHING_FAILED`,
    NEW_MENU_PUBLISHED: `${prefix}NEW_MENU_PUBLISHED`,
    NEW_MENU_PUBLISH_FAILED: `${prefix}NEW_MENU_PUBLISH_FAILED`,
    CLEAR_PUBLISH_MENU_ERROR: `${prefix}CLEAR_PUBLISH_MENU_ERROR`
};

export const ROUTE_TYPES_VALUES = {
    MENU: 0,
    RESTAURANT: 1,
    BILL_STATUS: 2,
    BILL_WAIT: 3,
    RESTAURANT_CLOSED: 4,
    AREA_NOT_ACTIVE: 5
};

export const ROUTE_TYPES_BY_VALUE = invert(ROUTE_TYPES_VALUES);

export const TABLE_SESSION_TYPE = {
    WAITER_PAYMENT: 0,
    PAYMENT_IN_ADVANCE: 1
};
